export interface ClientDomainDnsRecord {
  type: string;
  host: string;
  value: string;
}

export interface ClientDomainInstructions {
  domain: string;
  is_apex: boolean;
  records: ClientDomainDnsRecord[];
  cloudflare_warning: boolean;
  notes: string[];
  txt_record?: { host: string; value: string };
}

export interface ClientDomainPricing {
  addon: number;
  domain?: number;
  total: number;
  currency: string;
}

export interface ClientDomainAvailability {
  available: boolean;
  reason?: string;
  pricing?: ClientDomainPricing;
}

export interface ClientDomain {
  id: string;
  user_id: string;
  user?: { id: string; name: string; email: string };
  shortener_id?: string;
  user_recharge_id?: string;
  domain: string;
  type: 'byod' | 'purchase';
  status: string;
  is_apex: boolean;
  verification_token?: string;
  ownership_verified_at?: string;
  dns_verified_at?: string;
  dns_last_checked_at?: string;
  cloudflare_proxied: boolean;
  price_addon?: number;
  price_domain?: number;
  price_total?: number;
  addon_expires_at?: string;
  registrar_expires_at?: string;
  registrar_order_id?: string;
  registrar_driver?: string;
  // custo real pago no registrador, na MOEDA dele (US$) — não confundir com o
  // "repasse estimado (R$)" da tela de preços
  registrar_cost?: number;
  registrar_cost_currency?: string;
  transfer_requested_at?: string;
  transfer_paid_at?: string;
  transferred_at?: string;
  failure_reason?: string;
  suspend_reason?: string;
  created_at?: string;
  updated_at?: string;
}

export const CLIENT_DOMAIN_STATUS = {
  PENDING_OWNERSHIP: 'pending_ownership',
  PENDING_PAYMENT: 'pending_payment',
  REGISTERING: 'registering',
  PENDING_DNS: 'pending_dns',
  PROVISIONING_INFRA: 'provisioning_infra',
  ACTIVE: 'active',
  EXPIRED: 'expired',
  FAILED: 'failed',
  SUSPENDED: 'suspended',
  CANCELLED: 'cancelled',
  TRANSFERRED: 'transferred',
};

export const CLIENT_DOMAIN_HOLDING_STATUSES = [
  CLIENT_DOMAIN_STATUS.PENDING_OWNERSHIP,
  CLIENT_DOMAIN_STATUS.PENDING_PAYMENT,
  CLIENT_DOMAIN_STATUS.REGISTERING,
  CLIENT_DOMAIN_STATUS.PENDING_DNS,
  CLIENT_DOMAIN_STATUS.PROVISIONING_INFRA,
  CLIENT_DOMAIN_STATUS.ACTIVE,
  CLIENT_DOMAIN_STATUS.EXPIRED,
  CLIENT_DOMAIN_STATUS.SUSPENDED,
];
